// extracted by mini-css-extract-plugin
export default {"categoryLogo":"CategoryLogo-module__categoryLogo"};